export const rubles = value => Math.max(0, Math.floor(Number(value) || 0));

export function allocateGiftCards(cards, total) {
  let remaining = rubles(total);
  return [...cards].sort((a, b) =>
    (Date.parse(a.ExpiresAt) || Infinity) - (Date.parse(b.ExpiresAt) || Infinity) ||
    a.CurrentBalance - b.CurrentBalance
  ).reduce((payments, card) => {
    const amount = Math.min(rubles(card.CurrentBalance), remaining);
    if (amount) payments.push({ CardId: card.CardId, AmountRubles: amount });
    remaining -= amount;
    return payments;
  }, []);
}

export function clampGiftCards(selected, cards, total) {
  let remaining = rubles(total);
  const seen = new Set();
  return selected.reduce((payments, payment) => {
    const card = cards.find(card => card.CardId === payment.CardId);
    if (!card || seen.has(card.CardId)) return payments;
    seen.add(card.CardId);
    const amount = Math.min(rubles(payment.AmountRubles), rubles(card.CurrentBalance), remaining);
    payments.push({ CardId: card.CardId, AmountRubles: amount });
    remaining -= amount;
    return payments;
  }, []);
}

export function giftCardError(error) {
  const messages = {
    card_not_found: 'Сертификат не найден',
    card_already_bound: 'Сертификат уже добавлен в аккаунт',
    card_not_owned: 'Этот сертификат привязан к другому аккаунту',
    card_blocked: 'Сертификат заблокирован',
    card_expired: 'Срок действия сертификата истёк',
    customer_not_found: 'Не удалось найти аккаунт, войдите заново',
    insufficient_balance: 'На сертификате недостаточно средств',
  };
  if (error.status === 401) return 'Войдите в аккаунт заново';
  return messages[error.code] || error.clientMessage || 'Не удалось обработать подарочную карту. Попробуйте ещё раз.';
}
